






































































































































































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { GridOptions } from 'ag-grid-community'
import { TranslateResult } from 'vue-i18n'
import { KeyActionEnum, SnackbarStateEnum } from '@/types/enums'
import { hexToRgba } from '@/services/hex-to-rgba'
import { QcqCommonGridItem } from '@/types'
import {
  ASSIGN_EMPLOYEE_TO_REPLACEMENT,
  FETCH_REPLACEMENT_LIST, FETCH_REPLACEMENTS_DETAILS,
  FINISH_REPLACEMENT,
  LOAD_COMPETENCE,
  SAVE_REPLACEMENT_DETAILS,
  SET_DISPOSITION_JOB_STATUS_LIST, SET_IS_DISPOSITION_JOB_STATUS, UPDATE_REPLACEMENT_PERSON_LIST,
  UPDATE_REPLACEMENTS
} from '@/store/action-types'
import { Competence } from '@/model/qcq/Competence'
import CompetenceDialog from '@/components/disposition/CompetenceDialog.vue'
import DeleteDialog from '@/components/DeleteDialog.vue'
import TextAreaCellRenderer from '@/components/cell-renderer/TextAreaCellRenderer.vue'
import ArrayCellRenderer from '@/components/cell-renderer/ArrayCellRenderer.vue'
import SelectedEmployeeCellRenderer from '@/components/cell-renderer/SelectedEmployeeCellRenderer.vue'
import ReplacementSelectCellRenderer from '@/components/cell-renderer/ReplacementSelectCellRenderer.vue'
import WarningDialog from '@/components/WarningDialog.vue'
import { DispositionJobEmployee } from '@/model/disposition/DispositionJobEmployee'
import { GET_DISPOSITION_DEFAULT_DISTANCE, GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import ProgressCircular from '@/components/ProgressCircular.vue'
import moment from 'moment'
import WhatsAppCellRenderer from '@/components/cell-renderer/WhatsAppCellRenderer.vue'
import {
  AssignReplacementResponse,
  FinishReplacementResponse,
  ReplacementListResponse,
  ReplacementRowResponse, SaveReplacementDetailsResponse,
  UpdateReplacementListResponse, UpdateReplacementPersonListResponse
} from '@/types/service-response'
import DatePickerCell from '@/components/disposition/DatePickerCell.vue'
import TimePickerCell from '@/components/disposition/TimePickerCell.vue'
import {
  AssignEmployeeToReplacementPayload,
  ReplacementDetailsPayload,
  ReplacementDetailsReplacementsPayload,
  ReplacementPayload, ReplacementPersonListPayload
} from '@/types/payload'
import { Replacement } from '@/model/disposition/Replacement'
import { DispositionJobStatus } from '@/model/disposition/DispositionJobStatus'
import selectedEmployeeIconCellRenderer from '@/components/cell-renderer/SelectedEmployeeIconCellRenderer.vue'
import { KeyAction } from '@/model/KeyAction'
import { keyActionService } from '@/services/key-action-service'

class Create extends KeyAction {}
class Edit extends KeyAction {}
class Delete extends KeyAction {}

interface ReplacementRow {
  Selected: boolean
  Adressverantwortliche: string | null
  Bis: string | null
  Dauer: string
  EinsatzAm: string
  Notiz: string | null
  ProjektSichtDetailId: number
  STVID: number
  Stellvertretung: string | null
  StellvertretungID: number
  Von: string | null
  Wochentag: string | null
  VonBis: string
}

interface ComponentData {
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  inReplacementListSaveProgress: boolean
  inSaveProgress: boolean
  inAssignSaveProgress: boolean
  inFinishSaveProgress: boolean
  inSaveTableProgress: boolean
  gridData: Array<QcqCommonGridItem>
  gridDataResponse: Array<QcqCommonGridItem>
  gridOptions: GridOptions
  overlayNoRowsTemplate: string
  competenceList: Array<QcqCommonGridItem>
  showDialog: boolean
  showDeleteDialog: boolean
  showWarningDialog: boolean
  suitableEmployees: DispositionJobEmployee[]
  suitableEmployeesGridOptions: GridOptions
  defaultColDef: Object
  gridFrameworkComponents: Object
  validationRules: Array<Function>
  selectedCompetenceId: number | undefined
  selectedCompetenceData: QcqCommonGridItem | undefined
  originEmployeeInDistance: string
  employeeInDistance: string
  referenceDate: string | null
  isAssignedPerson: boolean
  isReadOnly: boolean
  loading: boolean

  isReplacementListEdit: boolean
  headers: any[]
  originReplacementListResponse: ReplacementRowResponse[]
  originReplacementList: ReplacementRow[]
  replacementList: ReplacementRow[]
  overlayNoRowsTemplateTable: string
  detailsId: number | null
  originalSuitableEmployees: DispositionJobEmployee[] | undefined

  keyActions: KeyAction[]
}

export default Vue.extend({
  name: 'DispositionRepresentativeDialog',

  components: {
    AgGridVue,
    CompetenceDialog,
    DeleteDialog,
    WarningDialog,
    ProgressCircular,
    DatePickerCell,
    TimePickerCell
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    dialogData: Object as () => Replacement | undefined,
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.addresses.required').toString()

    return {
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      inReplacementListSaveProgress: false,
      inSaveProgress: false,
      inAssignSaveProgress: false,
      inFinishSaveProgress: false,
      inSaveTableProgress: false,
      gridData: [],
      gridDataResponse: [],
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('employeeFormComponent.qcq.description').toString(), field: 'description' },
        ]
      },
      overlayNoRowsTemplate: "<span>"+this.$t('errors.noRowsToShow')+"</span>",
      competenceList: [],
      showDialog: false,
      showDeleteDialog: false,
      showWarningDialog: false,
      suitableEmployees: [],
      suitableEmployeesGridOptions: {
        columnDefs: [
          { headerName: '',field: 'employee', width: 40, cellRenderer: 'selectedEmployeeIconCellRenderer'},
          { headerName: this.$t('disposition.employee').toString(), field: 'employee', width: 210, cellRenderer: 'selectedEmployeeCellRenderer'},
          { headerName: this.$t('disposition.status').toString(), field: 'status', width: 150, cellRenderer: 'replacementSelectCellRenderer'},
          {
            headerName: this.$t('planningPage.monday').toString(),
            children: [
              { headerName: this.$t('disposition.vm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[0].morning ? 'X' : ''
                }
              },
              { headerName: this.$t('disposition.nm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[0].afternoon ? 'X' : ''
                }
              }
            ]
          },
          {
            headerName: this.$t('planningPage.tuesday').toString(),
            children: [
              { headerName: this.$t('disposition.vm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[1].morning ? 'X' : ''
                }
              },
              { headerName: this.$t('disposition.nm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[1].afternoon ? 'X' : ''
                }
              }
            ]
          },
          {
            headerName: this.$t('planningPage.wednesday').toString(),
            children: [
              { headerName: this.$t('disposition.vm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[2].morning ? 'X' : ''
                }
              },
              { headerName: this.$t('disposition.nm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[2].afternoon ? 'X' : ''
                }
              }
            ]
          },
          {
            headerName: this.$t('planningPage.thursday').toString(),
            children: [
              { headerName: this.$t('disposition.vm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[3].morning ? 'X' : ''
                }
              },
              { headerName: this.$t('disposition.nm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[3].afternoon ? 'X' : ''
                }
              }
            ]
          },
          {
            headerName: this.$t('planningPage.friday').toString(),
            children: [
              { headerName: this.$t('disposition.vm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[4].morning ? 'X' : ''
                }
              },
              { headerName: this.$t('disposition.nm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[4].afternoon ? 'X' : ''
                }
              }
            ]
          },
          {
            headerName: this.$t('planningPage.saturday').toString(),
            children: [
              { headerName: this.$t('disposition.vm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[5].morning ? 'X' : ''
                }
              },
              { headerName: this.$t('disposition.nm').toString(), width: 50,
                valueGetter: (params: any) => {
                  return params.data.days[5].afternoon ? 'X' : ''
                }
              }
            ]
          },
          { headerName: this.$t('disposition.distance').toString(), field: 'distance', width: 80 },
          { headerName: this.$t('disposition.placeOfResidence').toString(), field: 'placeOfResidence', width: 170},
          {headerName: this.$t('disposition.contact').toString(),
            children: [
              {  width: 60,
                cellRenderer:'whatsAppCellRenderer'
              },
              { headerName: this.$t('disposition.mobile').toString(), field: 'mobile', width: 110,
                cellRenderer: function(params) {
                  return `<a href="tel:${params.data.mobile}"> ${params.data.mobile} </a>`
                }
              },
              { headerName: this.$t('disposition.email').toString(), field: 'email', width: 150,
                cellRenderer: function(params) {
                  return `<a href="mailto:${params.data.email}"> ${params.data.email} </a>`
                }
              }
            ]
          },
          {headerName: this.$t('disposition.competence').toString(), field: 'competence', width: 190, cellRenderer: 'arrayCellRenderer' },
          {headerName: this.$t('disposition.note').toString(), field: 'note', cellRenderer:'textAreaCellRenderer'},
        ]
      },
      defaultColDef: {
        wrapText: true,
        autoHeight: true
      },
      gridFrameworkComponents: {
        selectedEmployeeIconCellRenderer: selectedEmployeeIconCellRenderer,
        selectedEmployeeCellRenderer: SelectedEmployeeCellRenderer,
        replacementSelectCellRenderer: ReplacementSelectCellRenderer,
        arrayCellRenderer: ArrayCellRenderer,
        textAreaCellRenderer: TextAreaCellRenderer,
        whatsAppCellRenderer: WhatsAppCellRenderer
      },
      validationRules: [required],
      selectedCompetenceId: undefined,
      selectedCompetenceData: undefined,
      originEmployeeInDistance: '0',
      employeeInDistance: '0',
      referenceDate: null,
      isAssignedPerson: false,
      isReadOnly: false,
      loading: false,

      isReplacementListEdit: false,
      headers: [
        { value: 'Selected', align: 'start', width: 80 },
        { text: this.$t('disposition.replacementTableLabel1').toString(), value: 'EinsatzAm', align: 'start', width: 200 },
        { text: this.$t('disposition.replacementTableLabel2').toString(), value: 'Wochentag', align: 'start', width: 150 },
        { text: this.$t('disposition.replacementTableLabel3').toString(), value: 'VonBis', align: 'start', width: 270 },
        { text: this.$t('disposition.replacementTableLabel4').toString(), value: 'Dauer', align: 'start', width: 150 },
        { text: this.$t('disposition.replacementTableLabel5').toString(), value: 'Adressverantwortliche', align: 'start', width: 200 },
        { text: this.$t('disposition.replacementTableLabel6').toString(), value: 'Stellvertretung', align: 'start', width: 200 },
        { text: this.$t('disposition.replacementTableLabel7').toString(), value: 'Notiz', align: 'start' },
      ],
      originReplacementListResponse: [],
      originReplacementList: [],
      replacementList: [],
      overlayNoRowsTemplateTable: this.$t('errors.noRowsToShow').toString(),
      detailsId: null,
      originalSuitableEmployees: undefined,

      keyActions: []
    }
  },

  computed: {
    selectedLocale (): string {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].code
    },

    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    isEnableCompetenceButtons (): boolean {
      if(this.selectedCompetenceData && !this.isReadOnly && !this.isAssignedPerson) {
        return true
      } else {
        return false
      }
    },

    isCancelButtonDisabled (): boolean {
      if(this.inSaveProgress || this.inAssignSaveProgress || this.inFinishSaveProgress || this.inSaveTableProgress) {
        return true
      } else {
        return false
      }
    },

    isAssignmentButtonEnabled (): boolean {
      if(this.detailsId && this.suitableEmployees.length !== 0) {
        const foundEmployee: DispositionJobEmployee | undefined = this.suitableEmployees.find((item: DispositionJobEmployee) => item.status === 5)
        if(foundEmployee && this.isFormSaveDisabled  && this.isPersonSaveDisabled && !this.isAssignedPerson && !this.isReadOnly) {
          return true
        } else {
          return false
        }
      }
      return false
    },

    isEndButtonEnabled (): boolean {
      return this.isAssignedPerson && !this.isReadOnly
    },

    isFormSaveDisabled (): boolean {
      if(this.dialogData) {
        if ((JSON.stringify(this.originReplacementList) !== JSON.stringify(this.replacementList) || JSON.stringify(_.orderBy(this.gridDataResponse, ['id'],['asc'])) !== JSON.stringify(_.orderBy(this.gridData, ['id'],['asc'])) || this.originEmployeeInDistance.toString() !== this.employeeInDistance.toString() || this.suitableEmployees.length === 0) && !this.isReplacementListEdit && !this.isAssignedPerson && !this.isReadOnly) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },

    isPersonSaveDisabled (): boolean {
      if(this.detailsId && this.suitableEmployees && !this.isAssignedPerson) {
        if(JSON.stringify(this.originalSuitableEmployees) !== JSON.stringify(this.suitableEmployees)) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    }

  },

  methods: {
    onKeydown (event: any): void {
      const action: any = keyActionService(event, this.keyActions)
      action && action.handle()
    },

    resolver (action: Create | Edit | Delete | null): boolean {
      if(action instanceof Create) {
        return !this.isReadOnly && !this.isAssignedPerson
      } else if(action instanceof Edit) {
        return this.isEnableCompetenceButtons
      } else if(action instanceof Delete) {
        return this.isEnableCompetenceButtons
      } else {
        return false
      }
    },

    onEditButtonClick (): void {
      this.isReplacementListEdit = true
    },

    onSuitableEmployeeChange(item: ReplacementRow): void {
      const foundEmployee: DispositionJobEmployee | undefined = this.suitableEmployees.find((i: DispositionJobEmployee) => i.employeeId === item.StellvertretungID)
      item.Stellvertretung = foundEmployee ? foundEmployee.employee : ''
    },

    onCancelReplacementListEdit (): void {
      this.isReplacementListEdit = false
      this.setReplacementListData(this.originReplacementListResponse)
    },

    onSaveReplacementListEdit (): void {
      this.updateReplacementList()
    },

    async updateReplacementList (): Promise<void> {
      this.inReplacementListSaveProgress = true

      const payload: ReplacementPayload[] = this.replacementList.map((item: ReplacementRow) => {
        return {
          ProjektSichtDetailId: item.ProjektSichtDetailId,
          STVID: item.STVID,
          EinsatzAm: item.EinsatzAm,
          Wochentag: item.Wochentag ? item.Wochentag : '',
          Von: item.Von ? item.Von : '',
          Bis: item.Bis ? item.Bis : '',
          Dauer: item.Dauer ? item.Dauer : '',
          Stellvertretung: item.Stellvertretung ? item.Stellvertretung : '',
          StellvertretungID: item.StellvertretungID,
          Adressverantwortliche: item.Adressverantwortliche ? item.Adressverantwortliche : '',
          Notiz: item.Notiz ? item.Notiz : '',
          Selected: item.Selected
        }
      })

      try {
        const response: UpdateReplacementListResponse = await this.$store.dispatch(UPDATE_REPLACEMENTS, payload)
        if(!response.IsError) {
          this.isReplacementListEdit = false
          this.fetchReplacementList()
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.inReplacementListSaveProgress = false
      }
    },

    getFormattedDate (date: string): string {
      return moment(date).format('DD.MM.YYYY')
    },

    getDayName (date: string): string {
      return moment(date).locale(this.selectedLocale).format("dddd")
    },

    onRowClicked (params: any): void {
      this.selectedCompetenceId = params.data.id
      const foundCompetence = this.gridData.find((item: QcqCommonGridItem) => item.id === this!.selectedCompetenceId)
      if(foundCompetence) {
        this.selectedCompetenceData = foundCompetence
      }
    },

    onAddCompetenceClick (): void {
      this.selectedCompetenceId = undefined
      this.selectedCompetenceData = undefined
      this.showDialog = true
    },

    create (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onAddCompetenceClick()
    },

    onEditCompetenceButtonClick (): void {
      this.showDialog = true
    },

    update (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onEditCompetenceButtonClick()
    },

    dialogSaved (payload: QcqCommonGridItem): void {
      if(this.selectedCompetenceData) {
        const index: number = this.gridData.indexOf(this.selectedCompetenceData)
        this.gridData.splice(index, 1, payload)
        this.showDialog = false
      } else {
        this.gridData.push(payload)
        this.showDialog = false
      }
      this.selectedCompetenceId = undefined
      this.selectedCompetenceData = undefined
    },

    closeDialog (): void {
      this.showDialog = false
    },

    onDeleteCompetenceButtonClick (): void {
      this.showDeleteDialog = true
    },

    delete (action?: KeyAction | null): void {
      if(action) {
        action.event.preventDefault()
      }

      this.onDeleteCompetenceButtonClick()
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
    },

    onDeleteDialogSave (): void {
      if(this.selectedCompetenceData) {
        const index: number = this.gridData.indexOf(this.selectedCompetenceData)
        this.gridData.splice(index, 1)
        this.showDeleteDialog = true
      }
      this.showDeleteDialog = false
      this.selectedCompetenceId = undefined
      this.selectedCompetenceData = undefined
    },

    onWarningDialogClose (): void {
      this.showWarningDialog = false
    },

    onWarningDialogSave (): void {
      this.saveReplacementDetails()
    },


    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate()) {
        if(this.suitableEmployees.length > 0) {
          this.showWarningDialog = true
        } else {
          this.saveReplacementDetails()
        }
      }
    },

    async saveReplacementDetails (): Promise<void> {
      this.inSaveProgress = true

      const replacementDetailsReplacements: ReplacementDetailsReplacementsPayload[] = this.replacementList.map((item: ReplacementRow) => {
        return {
          Date: moment(item.EinsatzAm).format('YYYY-MM-DD'),
          Duration: item.Dauer,
          Selected: item.Selected,
          ProjektSichtDetailId: item.ProjektSichtDetailId
        }
      })

      const competencies: number[] = this.gridData.map((item: QcqCommonGridItem) => {
        return item.id
      })

      const payload: ReplacementDetailsPayload = {
        AddressId: this.dialogData!.addressId,
        AbsenceId: this.dialogData!.absenceId,
        Radius: parseInt(this.employeeInDistance),
        Replacements: replacementDetailsReplacements,
        Competencies: competencies
      }

      try {
        const response: SaveReplacementDetailsResponse = await this.$store.dispatch(SAVE_REPLACEMENT_DETAILS, payload)
        if(!response.IsError) {
          this.originReplacementList = _.cloneDeep(this.replacementList)
          this.gridDataResponse = _.cloneDeep(this.gridData)
          this.setDetailsData(response)
          this.onWarningDialogClose()
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.inSaveProgress = false
      }
    },

    onAssignEmployeeClick (): void {
      this.assignEmployeeToReplacement()
    },

    async assignEmployeeToReplacement (): Promise<void> {
      this.inAssignSaveProgress = true
      const foundEmployee: DispositionJobEmployee | undefined = this.suitableEmployees.find((item: DispositionJobEmployee) => item.status === 5)

      const payload: AssignEmployeeToReplacementPayload = {
        employeeId: foundEmployee!.employeeId,
        detailsId: this.detailsId!
      }

      try {
        const response: AssignReplacementResponse = await this.$store.dispatch(ASSIGN_EMPLOYEE_TO_REPLACEMENT, payload)
        if(!response.IsError) {
          this.isAssignedPerson = true
          this.fetchReplacementList()
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.inAssignSaveProgress = false
      }
    },

    onFinishReplacementClick (): void {
      this.finishReplacement()
    },

    async finishReplacement (): Promise<void> {
      this.inFinishSaveProgress = true
      try {
        const response: FinishReplacementResponse = await this.$store.dispatch(FINISH_REPLACEMENT, this.detailsId)
        if(!response.IsError) {
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.$emit('fetchAbsences')
          this.isReadOnly = true
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.inFinishSaveProgress = false
      }
    },

    onPersonSaveButtonClick (): void {
      this.updateReplacementPersonList()
    },

    async updateReplacementPersonList (): Promise<void> {
      const payload: ReplacementPersonListPayload[] = this.suitableEmployees.map((item: DispositionJobEmployee) => {
        return {
          SelectionId : item.id,
          Status: item.status,
          Notiz : item.note ? item.note : ''
        }
      })

      this.inSaveTableProgress = true
      try {
        const response: UpdateReplacementPersonListResponse = await this.$store.dispatch(UPDATE_REPLACEMENT_PERSON_LIST, payload)
        if(!response.IsError) {
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          this.fetchReplacementsDetails()
        } else {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        }
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      } finally {
        this.inSaveTableProgress = false
      }
    },

    async fetchCompetenceList (): Promise<void> {
      this.$store.dispatch(LOAD_COMPETENCE, 1)
          .then((data: Array<Competence>) => {
            data.forEach((item: Competence) => {
              this.competenceList.push(item.commonGridData)
            })
          })
    },

    async fetchReplacementList (): Promise<void> {
      const response: ReplacementListResponse = await this.$store.dispatch(FETCH_REPLACEMENT_LIST, this.dialogData)
      if(!response.IsError && response.Data) {
        this.originReplacementListResponse = response.Data
        this.setReplacementListData(this.originReplacementListResponse)
      }
    },

    setReplacementListData (data: ReplacementRowResponse[]): void {
      this.replacementList = data.map((item: ReplacementRowResponse) => {
        return {
          Selected: item.Selected,
          Adressverantwortliche: item.Adressverantwortliche,
          Bis: item.Bis,
          Dauer: parseFloat(item.Dauer.toString()).toFixed(2),
          EinsatzAm: item.EinsatzAm ? item.EinsatzAm : '',
          Notiz: item.Notiz,
          ProjektSichtDetailId: item.ProjektSichtDetailId,
          STVID: item.STVID,
          Stellvertretung: item.Stellvertretung,
          StellvertretungID: item.StellvertretungID,
          Von: item.Von,
          Wochentag: item.Wochentag,
          VonBis: `${item.Von} - ${item.Bis}`
        }
      })

      if(this.originReplacementList.length === 0) {
        this.originReplacementList = _.cloneDeep(this.replacementList)
      }
    },

    async fetchReplacementsDetails (): Promise<void> {
      try {
        this.loading = true
        const response: SaveReplacementDetailsResponse = await this.$store.dispatch(FETCH_REPLACEMENTS_DETAILS, this.dialogData)
        this.loading = false
        if (!response.IsError) {
          this.setDetailsData(response)
        }
      } catch {
        this.loading = false
      }
    },

    setDetailsData (response: SaveReplacementDetailsResponse): void {

      this.isAssignedPerson = response.Status === 2
      this.isReadOnly = response.Status === 3

      if(response.DetailsId) {
        this.detailsId = response.DetailsId
      }

      if(response.LaufDetails) {
        this.originalSuitableEmployees = DispositionJobEmployee.createFromResponse(response.LaufDetails)
        this.suitableEmployees = DispositionJobEmployee.createFromResponse(response.LaufDetails)
        this.$store.dispatch(SET_IS_DISPOSITION_JOB_STATUS, false)
      }

      if(response.StatusDetails) {
        this.$store.dispatch(SET_DISPOSITION_JOB_STATUS_LIST, DispositionJobStatus.createFromResponse(response.StatusDetails))
      }

      if(response.Distance) {
        this.originEmployeeInDistance = response.Distance ? response.Distance : this.$store.getters[GET_DISPOSITION_DEFAULT_DISTANCE].toString()
        this.employeeInDistance = response.Distance ? response.Distance : this.$store.getters[GET_DISPOSITION_DEFAULT_DISTANCE].toString()
      } else {
        this.originEmployeeInDistance = this.employeeInDistance
      }

      if(response.Competencies) {
        this.gridData = []
        response.Competencies.forEach((item: number) => {
          const foundItem: QcqCommonGridItem | undefined = this.competenceList.find((i: QcqCommonGridItem) => i.id === item)
          if(foundItem) {
            this.gridData.push(foundItem)
          }
        })
        this.gridDataResponse = _.cloneDeep(this.gridData)
      }
    }

  },

  beforeMount () {
    this.keyActions = [
      new Create(KeyActionEnum.create, this.create, this.resolver,  null),
      new Edit(KeyActionEnum.edit, this.update, this.resolver, null),
      new Delete(KeyActionEnum.delete, this.delete, this.resolver, null)
    ]
  },

  mounted (): void {
    window.addEventListener('keydown', this.onKeydown)
    this.fetchCompetenceList()
    this.fetchReplacementsDetails()
    this.fetchReplacementList()

    this.employeeInDistance = this.$store.getters[GET_DISPOSITION_DEFAULT_DISTANCE].toString()
  },

  beforeDestroy (): void {
    window.removeEventListener('keydown', this.onKeydown)
  }
})
